import jquery from 'jquery'

const isTextArea = el => {
  return el.tagName.toUpperCase() === 'TEXTAREA'
}

const isTextAreaComposing = el => {
  const v = el.value
  return el.selectionStart !== v.length || v.substr(v.length - 2, 1) !== '\n'
}
const splitEm = em => {
  const token = ('' + em).split('.')
  if (token.length === 1) {
    const index = parseInt(token[0], 10)
    return [index, 'default']
  }
  const index = parseInt(token.pop(), 10)
  const scope = token.join('.')
  return [index, scope]
}

const doBlur = component => {
  const el = jquery(component.$el).find('input')
  if (el.length === 0) {
    return
  }
  el.blur && el.blur()
  component.blur && component.blur()
}

const doFocus = component => {
  if (typeof component.focus === 'function') {
    // For TextField/TextArea/Select
    // console.log('Type A')
    const el = jquery(component.$el).find('input')
    el.focus && el.focus()
    el.select && el.select()
    component.focus()
    // To open select.
    if (el.target) {
      component.onClick && component.onClick()
    }
  } else if (typeof component.onFocus === 'function') {
    // For Checkbox/Radio/Switch
    // console.log('Type B')
    const el = jquery(component.$el).find('input')
    el.focus && el.focus()
    component.onFocus()
  } else {
    // For Button
    // console.log('Type C')
    const el = jquery(component.$el)
    el.focus && el.focus()
  }
}

export default {
  data () {
    return {
      entermoveTargets: {},
      entermoveTargetNowIsComposing: false,
      entermoveTargetIntegrityEm: null,
      entermoveLastFocusRef: null,
      entermoveDebug: false,
      entermoveBackToTop: true,
      entermoveBeforeBackToTop: (emIndex, nextIndex, scope) => {
        return this.entermoveBackToTop
      }
    }
  },
  mounted () {
    // 共通のキーダウンアクション。
    // IME入力中判定はkeyup時にはすでにないので、ここで保持する。
    const keydownAction = e => {
      this.entermoveTargetNowIsComposing = e.originalEvent.isComposing
      this.entermoveTargetIntegrityEm = e.currentTarget.getAttribute('em')
    }
    // 共通のキーアップアクション。ここでフォーカス制御を行う。
    const keyupAction = e => {
      if (e.keyCode !== 13) {
        return
      }
      const t = e.currentTarget
      const em = t.getAttribute('em')
      if (em !== this.entermoveTargetIntegrityEm) {
        this.entermoveTargetIntegrityEm = em
        return
      }
      this.entermoveTargetIntegrityEm = em
      // textarea の場合は 末尾にカーソルがあって、その直前も改行の場合のみ発動
      if (isTextArea(t) && isTextAreaComposing(t)) {
        this.entermoveTargetNowIsComposing = false
        return
      }

      if (this.entermoveTargetNowIsComposing) {
        return
      }
      this.entermoveNext(em)
    }
    // Checkbox/Radio/Switchのクリック時補正。
    // VuetifyのCheckbox/Radio/Switchは、クリック時にコンポーネントはフォーカス状態となるが、
    // 実際のinputはフォーカス状態とならないため、マウスとentermoveを混ぜた操作を行った際に正しい挙動にならない。
    // それを補正するためにコンポーネントと内部inputでフォーカス状態を同期させる。
    const selectionControlsFocusSyncAction = e => {
      const t = e.currentTarget
      const $t = jquery(t)
      // 要素自体(の付近)をマウスクリックした場合
      let found = $t.find('input')
      if (found.length > 0) {
        found.focus()
        return
      }
      // ラベル要素をマウスクリックした場合
      found = $t.prev('.v-input--selection-controls__input').find('input')
      if (found.length > 0) {
        found.focus()
      }
    }

    const inputControlsSelector = [
      '.v-input input[em]',
      '.v-input textarea[em]'
    ].join(',')
    const selectionControlsSelector = [
      '.v-input--selection-controls.v-input--checkbox .v-input--selection-controls__input',
      '.v-input--selection-controls.v-input--checkbox .v-label',
      '.v-input--selection-controls.v-input--switch .v-input--selection-controls__input',
      '.v-input--selection-controls.v-input--switch .v-label',
      '.v-input--selection-controls.v-input--radio-group .v-input--selection-controls__input',
      '.v-input--selection-controls.v-input--radio-group .v-label'
    ].join(',')
    jquery(document).on('keydown', inputControlsSelector, keydownAction)
    jquery(document).on('keyup', inputControlsSelector, keyupAction)
    jquery(document).on(
      'click',
      selectionControlsSelector,
      selectionControlsFocusSyncAction
    )
    this.$once('hook:beforeDestroy', () => {
      jquery(document).off('keydown', inputControlsSelector, keydownAction)
      jquery(document).off('keyup', inputControlsSelector, keyupAction)
      jquery(document).off(
        'click',
        selectionControlsSelector,
        selectionControlsFocusSyncAction
      )
    })
    // リフレッシュ
    this.entermoveRefresh()
  },
  methods: {
    entermoveConfigure (options) {
      this.entermoveDebug = options.debug || false
      this.entermoveBackToTop =
        options.backToTop === undefined ? true : options.backToTop
      if (typeof options.beforeBackToTop === 'function') {
        this.entermoveBeforeBackToTop = options.beforeBackToTop
      }
    },
    entermoveRefresh () {
      // NOTE 遅延コンポーネントが後からレンダリングされる場合に対応するための遅延処置。
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          this.entermoveTargets = {}
          this._asyncEntermoveRefresh()
          return resolve()
        }, 15)
      })
    },
    _asyncEntermoveRefresh () {
      this._entermoveRefreshRecursive(this)
      Object.keys(this.entermoveTargets).forEach(key => {
        let scopedTargets = this.entermoveTargets[key]
        if (scopedTargets.length === 0) {
          return
        }
        scopedTargets = scopedTargets.sort(
          (a, b) => a.$data.emIndex - b.$data.emIndex
        )
        // Scope別にリンクリストを構築する。
        let prevTarget = null
        let first = null
        for (const target of scopedTargets) {
          if (prevTarget !== null) {
            prevTarget.$data.emNext = target.$data.emIndex
            prevTarget = target
          } else {
            prevTarget = target
            first = target
          }
        }
        scopedTargets[scopedTargets.length - 1].$data.emNext =
          first.$data.emIndex
        this.entermoveTargets[key] = scopedTargets
      })
      if (this.entermoveDebug) {
        Object.keys(this.entermoveTargets).forEach(key => {
          let scopedTargets = this.entermoveTargets[key]
          for (const target of scopedTargets) {
            this._log(
              `[node=${target.$vnode.tag}][uid=${
                target._uid
              }][scope=${key}] : [${target.$data.emIndex} => ${
                target.$data.emNext
              }]`
            )
          }
        })
      }
    },
    _registerIfNotYet (target, index, scope) {
      target.$data.emIndex = index
      target.$data.emScope = scope
      this.entermoveTargets[scope] = this.entermoveTargets[scope] || []
      const found = this.entermoveTargets[scope].find(
        c => c.$data.emIndex === target.$data.emIndex
      )
      if (!found) {
        this.entermoveTargets[scope].push(target)
      }
    },
    _entermoveRefreshRecursive (self) {
      // 自分の$attrsを処理
      if (self.$attrs && self.$attrs.em) {
        const [index, scope] = splitEm(self.$attrs.em)
        this._registerIfNotYet(self, index, scope)
      }
      // 自分の$refsを確認。
      // $refs配下はComponentがobjectの場合と、配列の場合の２パターンある。
      Object.keys(self.$refs).forEach(key => {
        let refs = self.$refs[key]
        refs = refs instanceof Array ? refs : [refs]
        for (const ref of refs) {
          if (ref && ref.$attrs && ref.$attrs.em) {
            const [index, scope] = splitEm(ref.$attrs.em)
            this._registerIfNotYet(ref, index, scope)
          }
          // $refs配下コンポーネントが$childrenを持っている可能性があるので再帰処理。
          if (ref && ref.$children) {
            for (const child of ref.$children) {
              this._entermoveRefreshRecursive(child)
            }
          }
        }
      })
      // 自分の$childrenを再帰処理。
      for (const child of self.$children) {
        this._entermoveRefreshRecursive(child)
      }
    },
    entermoveNext (em) {
      this._log(`Move request from [${em}]`)
      const [index, scope] = splitEm(em)
      if (!this.entermoveTargets[scope]) {
        this._warn(`Scope [${em}] is not registered.`)
        return
      }
      const me = this.entermoveTargets[scope].find(
        component => component.$data.emIndex === index
      )
      if (!me) {
        this._warn(`Index [${index}] in [${scope}] is not registered.`)
        return
      }
      const nx = me.$data.emNext
      if (!nx) {
        this._warn(`Next for [${em}] is not defined.`)
        return
      }
      const next = this.entermoveTargets[scope].find(
        component => component.$data.emIndex === nx
      )
      if (!next) {
        this._warn(`Next target [${nx}] in [${scope}] is not registered.`)
        return
      }
      this._log(`[${index} => ${nx}] in [${scope}]`)
      if (index < nx) {
        doBlur(me)
        doFocus(next)
        this.entermoveLastFocusRef = next
        return
      }
      if (this.entermoveBeforeBackToTop(index, nx, scope)) {
        doBlur(me)
        doFocus(next)
        this.entermoveLastFocusRef = next
      }
    },
    entermoveTo (em) {
      this._log(`Move request to [${em}]`)
      const me = this.entermoveLastFocusRef
      let index = me ? me.$data.emIndex : -1

      const [nx, scope] = splitEm(em)
      if (!this.entermoveTargets[scope]) {
        this._warn(`Scope [${em}] is not registered.`)
        return
      }
      const next = this.entermoveTargets[scope].find(
        component => component.$data.emIndex === nx
      )
      if (!next) {
        this._warn(`Next target [${nx}] in [${scope}] is not registered.`)
        return
      }
      this._log(`[${index} => ${nx}] in [${scope}]`)
      me && doBlur(me)
      doFocus(next)
      this.entermoveLastFocusRef = next
    },
    _log (v) {
      if (this.entermoveDebug) {
        console.log(`Entermove: ${v}`)
      }
    },
    _warn (v) {
      console.warn(`Entermove: ${v}`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/mixins/entermove.js